<template>
    <v-container fluid>
        <v-overlay :value="isLoading">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <div class="d-flex flex-row">
            <h2>{{ dbDevice.name }}</h2>
            <v-spacer></v-spacer>
            <v-btn :to="{ name: 'WinchDetail', params: { device_id: dbDevice.id } }" color="success" small><v-icon>mdi-cog-outline</v-icon></v-btn>
        </div>
        <v-divider class="mb-3"></v-divider>
        <!-- ============================================= -->
        <v-row>
            <v-col cols="4" class="pr-0">
                <v-menu v-model="dispCalender" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field class="text-body-1" outlined dense v-model="targetDate" readonly v-bind="attrs" v-on="on" background-color="white"></v-text-field>
                    </template>
                    <v-date-picker v-model="targetDate" @input="dispCalender = false" locale="ja" :max="maxDate" @change="axiosGetWinchSummary()"></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="4" class="pr-0">
                <v-select outlined dense v-model="daySpanValue" :items="daySpanOptions" @change="axiosGetWinchSummary()"></v-select>
            </v-col>
            <v-col cols="4">
                <v-select outlined dense v-model="deepFilterValue" :items="deepFilterOptions" @change="axiosGetWinchSummary()"></v-select>
            </v-col>
        </v-row>
        <!-- ============================================= -->

        <!-- ################# 水温 ##################################### -->
        <div v-show="chartDataSetWater">
            <div class="elevation-5" style="position: relative; height: auto; overflow: hidden">
                <v-card elevation="1">
                    <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">水温 (℃)</h4></v-card-title>

                    <div class="ma-5 mb-3">
                        <v-select label="カラーレンジ" outlined hide-details dense v-model="heatRangeWater" :items="heatRangeWaterOptions" style="width: 280px">
                            <template #selection>
                                <span>{{ heatRangeWater.min }}℃</span>
                                <v-img :src="colorBarImg" width="120" class="mx-1"></v-img>
                                <span>{{ heatRangeWater.max }}℃</span>
                            </template>
                        </v-select>
                    </div>

                    <comp-matrix :matrixData="chartDataSetWater" :matrixRange="heatRangeWater" matrixType="jet" style="height: 300px"></comp-matrix>
                    <v-divider class="ma-5"></v-divider>
                    <comp-chart-winch-water :chartDataChild="chartDataSetWater" :yRange="chartRange.water" style="height: 400px" />
                </v-card>
            </div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
        </div>
        <!-- ################# 有害プランクトン ##################################### -->
        <div v-show="chartDataSetFSI">
            <div class="elevation-5" style="position: relative; height: auto; overflow: hidden">
                <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
                    <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">有害プランクトン</h4></v-card-title>

                    <div class="ma-5 mb-3">
                        <v-select label="カラーレンジ" outlined hide-details dense v-model="heatRangeFSI" :items="heatRangeFSIOptions" style="width: 280px">
                            <template #selection>
                                <span>{{ heatRangeFSI.min }}</span>
                                <v-img :src="colorBarImg" width="120" class="mx-1"></v-img>
                                <span>{{ heatRangeFSI.max }}</span>
                            </template>
                        </v-select>
                    </div>

                    <comp-matrix :matrixData="chartDataSetFSI" :matrixRange="heatRangeFSI" matrixType="jet" style="height: 300px"></comp-matrix>
                    <v-divider class="ma-5"></v-divider>
                    <comp-chart-turbidity :chartDataChild="chartDataSetFSI" :yRange="chartRange.fsi" style="height: 400px" />
                </v-card>
            </div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
        </div>
        <!-- ################## DO ################################### -->
        <div v-show="chartDataSetOxygen">
            <div class="elevation-5" style="position: relative; height: auto; overflow: hidden">
                <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
                    <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">DO (mg/L)</h4></v-card-title>

                    <div class="ma-5 mb-3">
                        <v-select label="カラーレンジ" outlined hide-details dense v-model="heatRangeOxygen" :items="heatRangeOxygenOptions" style="width: 280px">
                            <template #selection>
                                <span>{{ heatRangeOxygen.min }}</span>
                                <v-img :src="colorBarImg" width="120" class="mx-1"></v-img>
                                <span>{{ heatRangeOxygen.max }}</span>
                            </template>
                        </v-select>
                    </div>

                    <comp-matrix :matrixData="chartDataSetOxygen" :matrixRange="heatRangeOxygen" matrixType="jet" style="height: 300px"></comp-matrix>
                    <v-divider class="ma-5"></v-divider>
                    <comp-chart-oxygen :chartDataChild="chartDataSetOxygen" :yRange="chartRange.oxygen" style="height: 400px" />
                </v-card>
            </div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
        </div>
        <!-- ################## 実用 塩分 #################################### -->
        <div v-show="chartDataSetSalinity">
            <div class="elevation-5" style="position: relative; height: auto; overflow: hidden">
                <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
                    <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">塩分</h4></v-card-title>

                    <div class="ma-5 mb-3">
                        <v-select label="カラーレンジ" outlined hide-details dense v-model="heatRangeSalinity" :items="heatRangeSalinityOptions" style="width: 280px">
                            <template #selection>
                                <span>{{ heatRangeSalinity.min }}</span>
                                <v-img :src="colorBarImg" width="120" class="mx-1"></v-img>
                                <span>{{ heatRangeSalinity.max }}</span>
                            </template>
                        </v-select>
                    </div>

                    <comp-matrix :matrixData="chartDataSetSalinity" :matrixRange="heatRangeSalinity" matrixType="jet" style="height: 300px"></comp-matrix>
                    <v-divider class="ma-5"></v-divider>
                    <comp-chart-salinity :chartDataChild="chartDataSetSalinity" :yRange="chartRange.salinity" style="height: 400px" />
                </v-card>
            </div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
        </div>
        <!-- ################# クロロ ##################################### -->
        <div v-show="chartDataSetChloro">
            <div class="elevation-5" style="position: relative; height: auto; overflow: hidden">
                <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
                    <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">クロロフィル (ppb)</h4></v-card-title>

                    <div class="ma-5 mb-3">
                        <v-select label="カラーレンジ" outlined hide-details dense v-model="heatRangeChloro" :items="heatRangeChloroOptions" style="width: 280px">
                            <template #selection>
                                <span>{{ heatRangeChloro.min }}</span>
                                <v-img :src="colorBarImg" width="120" class="mx-1"></v-img>
                                <span>{{ heatRangeChloro.max }}</span>
                            </template>
                        </v-select>
                    </div>

                    <comp-matrix :matrixData="chartDataSetChloro" :matrixRange="heatRangeChloro" matrixType="jet" style="height: 300px"></comp-matrix>
                    <v-divider class="ma-5"></v-divider>
                    <comp-chart-chloro :chartDataChild="chartDataSetChloro" :yRange="chartRange.chlorophyll" style="height: 400px" />
                </v-card>
            </div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
        </div>
        <!-- ################# 濁度 ##################################### -->
        <div v-show="chartDataSetTurbidity">
            <div class="elevation-5" style="position: relative; height: auto; overflow: hidden">
                <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
                    <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">濁度 (FTU)</h4></v-card-title>

                    <div class="ma-5 mb-3">
                        <v-select label="カラーレンジ" outlined hide-details dense v-model="heatRangeTurbidity" :items="heatRangeTurbidityOptions" style="width: 280px">
                            <template #selection>
                                <span>{{ heatRangeTurbidity.min }}</span>
                                <v-img :src="colorBarImg" width="120" class="mx-1"></v-img>
                                <span>{{ heatRangeTurbidity.max }}</span>
                            </template>
                        </v-select>
                    </div>

                    <comp-matrix :matrixData="chartDataSetTurbidity" :matrixRange="heatRangeTurbidity" matrixType="jet" style="height: 300px"></comp-matrix>
                    <v-divider class="ma-5"></v-divider>
                    <comp-chart-turbidity :chartDataChild="chartDataSetTurbidity" :yRange="chartRange.turbidity" style="height: 400px" />
                </v-card>
            </div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
            <div class="ma-5">&nbsp;</div>
        </div>
        <!-- ########################################################### -->
        <!-- =============================================
        <v-divider></v-divider>
        <v-card class="text-center py-3">
            <div class="mx-3 overflow-x-auto">
                <v-btn-toggle v-model="deepBtn" color="deep-purple accent-3" dense mandatory @change="createChartData()">
                    <v-btn value="1">水深1m</v-btn>
                    <v-btn value="2">水深2m</v-btn>
                    <v-btn value="3">水深3m</v-btn>
                    <v-btn value="4">水深4m</v-btn>
                    <v-btn value="5">水深5m</v-btn>
                    <v-btn value="6">水深6m</v-btn>
                    <v-btn value="7">水深7m</v-btn>
                    <v-btn value="8">水深8m</v-btn>
                    <v-btn value="9">水深9m</v-btn>
                    <v-btn value="10">水深10m</v-btn>
                </v-btn-toggle>
            </div>
        </v-card>
        ============================================= -->
    </v-container>
</template>

<script>
import CompChartWinchWater from "@/components/CompChartWinchWater";
import CompChartChloro from "@/components/CompChartChloro";
import CompChartTurbidity from "@/components/CompChartTurbidity";
import CompChartSalinity from "@/components/CompChartSalinity";
import CompChartOxygen from "@/components/CompChartOxygen";
import CompMatrix from "@/components/CompMatrix.vue";

export default {
    name: "WinchSummary",
    components: {
        CompChartWinchWater,
        CompChartChloro,
        CompChartTurbidity,
        CompChartSalinity,
        CompChartOxygen,
        CompMatrix,
    },
    //##################################################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            device_id: 0,
            dbDevice: { id: 0, name: "" },
            dbWinchSummary: [],
            deepBtn: 0,
            dispCalender: false,
            targetDate: this.$moment().format("YYYY-MM-DD"),
            maxDate: this.$moment().format("YYYY-MM-DD"),
            isLoading: false,
            colorBarImg: require("@/assets/color-bar.png"),
            //---------------------------------
            chartDataSetWater: { datasets: [] },
            chartDataSetChloro: { datasets: [] },
            chartDataSetTurbidity: { datasets: [] },
            chartDataSetSalinity: { datasets: [] },
            chartDataSetSalinitySG: { datasets: [] },
            chartDataSetOxygen: { datasets: [] },
            chartDataSetFSI: { datasets: [] },
            //---------------------------------
            daySpanValue: 7,
            daySpanOptions: [
                { text: "1日間", value: 1 },
                { text: "2日間", value: 2 },
                { text: "7日間", value: 7 },
            ],
            //---------------------------------
            heatRangeWater: { min: 20, max: 30 },
            heatRangeFSI: { min: 0, max: 2 },
            heatRangeOxygen: { min: 0, max: 5 },
            heatRangeSalinity: { min: 25, max: 35 },
            heatRangeChloro: { min: 0, max: 10 },
            heatRangeTurbidity: { min: 0, max: 2 },

            heatRangeWaterOptions: [
                { text: "自動", value: { min: 0, max: 10 } },
                { text: "5度±5 (0〜10)", value: { min: 0, max: 10 } },
                { text: "10度±5 (5〜15)", value: { min: 5, max: 15 } },
                { text: "15度±5 (10〜20)", value: { min: 10, max: 20 } },
                { text: "20度±5 (15〜25)", value: { min: 15, max: 25 } },
                { text: "25度±5 (20〜30)", value: { min: 20, max: 30 } },
                { text: "30度±5 (25〜35)", value: { min: 25, max: 35 } },
                { text: "35度±5 (30〜40)", value: { min: 30, max: 40 } },
                { text: "10度±10 (0〜20)", value: { min: 0, max: 20 } },
                { text: "15度±10 (5〜25)", value: { min: 5, max: 25 } },
                { text: "20度±10 (10〜30)", value: { min: 10, max: 30 } },
                { text: "25度±10 (15〜35)", value: { min: 15, max: 35 } },
            ],
            heatRangeChloroOptions: [{ text: "自動", value: { min: 0, max: 10 } }],
            heatRangeSalinityOptions: [{ text: "自動", value: { min: 0, max: 10 } }],
            heatRangeOxygenOptions: [{ text: "自動", value: { min: 0, max: 10 } }],
            heatRangeTurbidityOptions: [{ text: "自動", value: { min: 0, max: 10 } }],
            heatRangeFSIOptions: [{ text: "自動", value: { min: 0, max: 10 } }],
            //---------------------------------
            deepFilterValue: 0,
            deepFilterOptions: [
                { text: "全層", value: 0 },
                { text: "1m", value: 1 },
                { text: "2m", value: 2 },
                { text: "3m", value: 3 },
                { text: "4m", value: 4 },
                { text: "5m", value: 5 },
                { text: "6m", value: 6 },
                { text: "7m", value: 7 },
                { text: "8m", value: 8 },
                { text: "9m", value: 9 },
                { text: "10m", value: 10 },
            ],
            //---------------------------------
            chartRange: {
                water: { min: 0, max: 0 },
                chlorophyll: { min: 0, max: 0 },
                turbidity: { min: 0, max: 0 },
                salinity: { min: 0, max: 0 },
                oxygen: { min: 0, max: 0 },
                fsi: { min: 0, max: 3 },
            },
            //---------------------------------
            chartColor: {
                water_A: "#7fd1ea",
                water_B: "#386ddd",
                water_C: "#000d88",
                water_D: "#000d88",
                water_E: "#000d88",
                salinity_A: "#bbbbbb",
                salinity_B: "#808080",
                salinity_C: "#2d2d2d",
                salinity_D: "#2d2d2d",
                salinity_E: "#2d2d2d",
                oxygen_A: "#a3c4ff",
                oxygen_B: "#7b7bc1",
                oxygen_C: "#545484",
                oxygen_D: "#545484",
                oxygen_E: "#545484",
                chlorophyll_A: "#87f098",
                chlorophyll_B: "#8fbc8f",
                chlorophyll_C: "#006400",
                chlorophyll_D: "#006400",
                chlorophyll_E: "#006400",
                turbidity_A: "#daa520",
                turbidity_B: "#b8860b",
                turbidity_C: "#aa1529",
                turbidity_D: "#aa1529",
                turbidity_E: "#aa1529",
            },
            //---------------------------------
            chartLabel: {
                water_A: "水温",
                water_B: "水温",
                water_C: "水温",
                water_D: "水温",
                water_E: "水温",
                salinity_A: "塩分",
                salinity_B: "塩分",
                salinity_C: "塩分",
                salinity_D: "塩分",
                salinity_E: "塩分",
                oxygen_A: "DO",
                oxygen_B: "DO",
                oxygen_C: "DO",
                oxygen_D: "DO",
                oxygen_E: "DO",
                chlorophyll_A: "クロロ",
                chlorophyll_B: "クロロ",
                chlorophyll_C: "クロロ",
                chlorophyll_D: "クロロ",
                chlorophyll_E: "クロロ",
                turbidity_A: "濁度",
                turbidity_B: "濁度",
                turbidity_C: "濁度",
                turbidity_D: "濁度",
                turbidity_E: "濁度",
            },
            //---------------------------------
        };
    },
    //##################################################################################
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        this.device_id = this.$route.params.device_id;
        this.localRangeUpdate();
        await this.axiosGetDevice();
        await this.axiosGetWinchSummary();
        //-----------------------
        window.scrollTo(0, 0);
        await new Promise((r) => setTimeout(r, 3000));
        //-----------------------
    },
    //##################################################################################
    beforeDestroy: function () {},
    //##################################################################################
    mounted: function () {},
    //##################################################################################
    watch: {
        $route: async function (to, from) {
            if (from.fullPath !== to.fullPath) {
                this.device_id = to.params.device_id;
                this.axiosGetDevice();
                await this.axiosGetWinchSummary();
            }
        },
    },
    //##################################################################################
    methods: {
        //====================================================
        async localRangeUpdate() {
            if (this.$localStorage.get("chart.range.json") != undefined) {
                let localRange = JSON.parse(this.$localStorage.get("chart.range.json"));
                if (Number(localRange["water"]["min"])) this.chartRange.water.min = Number(localRange["water"]["min"]);
                if (Number(localRange["water"]["max"])) this.chartRange.water.max = Number(localRange["water"]["max"]);
                if (Number(localRange["salinity"]["min"])) this.chartRange.salinity.min = Number(localRange["salinity"]["min"]);
                if (Number(localRange["salinity"]["max"])) this.chartRange.salinity.max = Number(localRange["salinity"]["max"]);
                if (Number(localRange["oxygen"]["min"])) this.chartRange.oxygen.min = Number(localRange["oxygen"]["min"]);
                if (Number(localRange["oxygen"]["max"])) this.chartRange.oxygen.max = Number(localRange["oxygen"]["max"]);
                if (Number(localRange["chlorophyll"]["min"])) this.chartRange.chlorophyll.min = Number(localRange["chlorophyll"]["min"]);
                if (Number(localRange["chlorophyll"]["max"])) this.chartRange.chlorophyll.max = Number(localRange["chlorophyll"]["max"]);
                if (Number(localRange["turbidity"]["min"])) this.chartRange.turbidity.min = Number(localRange["turbidity"]["min"]);
                if (Number(localRange["turbidity"]["max"])) this.chartRange.turbidity.max = Number(localRange["turbidity"]["max"]);
                if (Number(localRange["harmful"]["min"])) this.chartRange.fsi.min = Number(localRange["harmful"]["min"]);
                if (Number(localRange["harmful"]["max"])) this.chartRange.fsi.max = Number(localRange["harmful"]["max"]);
            }
        },
        //====================================================
        async axiosGetDevice() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: {
                    id: this.device_id,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevice = response.data.json[0];
            });
        },
        //====================================================
        async axiosGetWinchSummary() {
            this.isLoading = true;
            //------------------------
            await new Promise((r) => setTimeout(r, 100 * this.daySpanValue));
            //------------------------
            const sdays = (this.daySpanValue - 1) * -1;
            const sdate = this.$moment(this.targetDate).add(sdays, "days").format("YYYY-MM-DD");
            const edate = this.$moment(this.targetDate).add(0, "days").format("YYYY-MM-DD");
            await this.axios({
                method: "GET",
                url: "/web/api/winch-summary/" + this.device_id + "/" + sdate + "/" + edate,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            })
                .then((response) => {
                    this.dbWinchSummary = response.data.json;
                    this.createChartData();
                    this.matrixChartMinMax();
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.isLoading = false;
                    const { status, statusText } = err.response;
                    alert(status + " : " + statusText);
                });
        },
        //====================================================
        matrixChartMinMax() {
            let water_min = null;
            let water_max = null;
            let oxygen_min = null;
            let oxygen_max = null;
            let salinity_min = null;
            let salinity_max = null;
            let chloro_min = null;
            let chloro_max = null;
            let turbidity_min = null;
            let turbidity_max = null;
            let fsi_min = null;
            let fsi_max = null;
            for (let rec of this.dbWinchSummary) {
                //const time = rec["sensor_time"];
                //const deep = rec["sensor_deep"];
                const key = rec["sensor_key"];
                const val = rec["sensor_val"];
                if (key == "water_temp" && val != null) {
                    if (water_min == null || water_min > val) water_min = val;
                    if (water_max == null || water_max < val) water_max = val;
                }
                if (key == "oxygen" && val != null) {
                    if (oxygen_min == null || oxygen_min > val) oxygen_min = val;
                    if (oxygen_max == null || oxygen_max < val) oxygen_max = val;
                }
                if (key == "salinity" && val != null) {
                    if (salinity_min == null || salinity_min > val) salinity_min = val;
                    if (salinity_max == null || salinity_max < val) salinity_max = val;
                }
                if (key == "chlorophyll" && val != null) {
                    if (chloro_min == null || chloro_min > val) chloro_min = val;
                    if (chloro_max == null || chloro_max < val) chloro_max = val;
                }
                if (key == "turbidity" && val != null) {
                    if (turbidity_min == null || turbidity_min > val) turbidity_min = val;
                    if (turbidity_max == null || turbidity_max < val) turbidity_max = val;
                }
                if (key == "fsi" && val != null) {
                    if (fsi_min == null || fsi_min > val) fsi_min = val;
                    if (fsi_max == null || fsi_max < val) fsi_max = val;
                }
            }
            if (water_min && water_max) {
                water_min = Math.floor(water_min);
                water_max = Math.ceil(water_max);
                //------------------
                if (water_min < 0) water_min = 0; // 水温が-4.335e+22 = -43350000000000000000000の場合はゼロにする
                if (water_max > 50) water_max = 50;
                //------------------
                this.heatRangeWater = { min: water_min, max: water_max };
                this.heatRangeWaterOptions.shift();
                this.heatRangeWaterOptions.unshift({ text: "自動", value: { min: water_min, max: water_max } });
            }
            if (oxygen_min && oxygen_max) {
                oxygen_min = Math.floor(oxygen_min);
                oxygen_max = Math.ceil(oxygen_max);
                oxygen_min = 0;
                oxygen_max = 10;
                this.heatRangeOxygen = { min: oxygen_min, max: oxygen_max };
                this.heatRangeOxygenOptions.shift();
                this.heatRangeOxygenOptions.unshift({ text: "自動", value: { min: oxygen_min, max: oxygen_max } });
            }
            if (salinity_min && salinity_max) {
                salinity_min = Math.floor(salinity_min);
                salinity_max = Math.ceil(salinity_max);
                salinity_min = 20;
                salinity_max = 35;
                this.heatRangeSalinity = { min: salinity_min, max: salinity_max };
                this.heatRangeSalinityOptions.shift();
                this.heatRangeSalinityOptions.unshift({ text: "自動", value: { min: salinity_min, max: salinity_max } });
            }
            if (chloro_min && chloro_max) {
                chloro_min = Math.floor(chloro_min);
                chloro_max = Math.ceil(chloro_max);
                chloro_min = 0;
                chloro_max = 10;
                this.heatRangeChloro = { min: chloro_min, max: chloro_max };
                this.heatRangeChloroOptions.shift();
                this.heatRangeChloroOptions.unshift({ text: "自動", value: { min: chloro_min, max: chloro_max } });
            }
            if (turbidity_min && turbidity_max) {
                turbidity_min = Math.floor(turbidity_min);
                turbidity_max = Math.ceil(turbidity_max);
                turbidity_min = 0;
                turbidity_max = 10;
                this.heatRangeTurbidity = { min: turbidity_min, max: turbidity_max };
                this.heatRangeTurbidityOptions.shift();
                this.heatRangeTurbidityOptions.unshift({ text: "自動", value: { min: turbidity_min, max: turbidity_max } });
            }
            if (fsi_min && fsi_max) {
                fsi_min = Math.floor(fsi_min);
                fsi_max = Math.ceil(fsi_max);
                fsi_min = 1.5;
                fsi_max = 2.5;
                this.heatRangeFSI = { min: fsi_min, max: fsi_max };
                this.heatRangeFSIOptions.shift();
                this.heatRangeFSIOptions.unshift({ text: "自動", value: { min: fsi_min, max: fsi_max } });
            }
        },
        //====================================================
        createChartData() {
            //-----------------------------------------
            this.chartDataSetWater = { datasets: [] };
            this.chartDataSetOxygen = { datasets: [] };
            this.chartDataSetSalinity = { datasets: [] };
            this.chartDataSetChloro = { datasets: [] };
            this.chartDataSetTurbidity = { datasets: [] };
            this.chartDataSetFSI = { datasets: [] };
            let water_A = [];
            let water_B = [];
            let water_C = [];
            let water_D = [];
            let water_E = [];
            let water_F = [];
            let water_G = [];
            let water_H = [];
            let water_I = [];
            let water_J = [];
            let oxygen_A = [];
            let oxygen_B = [];
            let oxygen_C = [];
            let oxygen_D = [];
            let oxygen_E = [];
            let oxygen_F = [];
            let oxygen_G = [];
            let oxygen_H = [];
            let oxygen_I = [];
            let oxygen_J = [];
            let salinity_A = [];
            let salinity_B = [];
            let salinity_C = [];
            let salinity_D = [];
            let salinity_E = [];
            let salinity_F = [];
            let salinity_G = [];
            let salinity_H = [];
            let salinity_I = [];
            let salinity_J = [];
            let chlorophyll_A = [];
            let chlorophyll_B = [];
            let chlorophyll_C = [];
            let chlorophyll_D = [];
            let chlorophyll_E = [];
            let chlorophyll_F = [];
            let chlorophyll_G = [];
            let chlorophyll_H = [];
            let chlorophyll_I = [];
            let chlorophyll_J = [];
            let turbidity_A = [];
            let turbidity_B = [];
            let turbidity_C = [];
            let turbidity_D = [];
            let turbidity_E = [];
            let turbidity_F = [];
            let turbidity_G = [];
            let turbidity_H = [];
            let turbidity_I = [];
            let turbidity_J = [];
            let fsi_A = [];
            let fsi_B = [];
            let fsi_C = [];
            let fsi_D = [];
            let fsi_E = [];
            let fsi_F = [];
            let fsi_G = [];
            let fsi_H = [];
            let fsi_I = [];
            let fsi_J = [];
            //-------------------
            let ct_water = 0;
            let ct_oxygen = 0;
            let ct_salinity = 0;
            let ct_chlorophyll = 0;
            let ct_turbidity = 0;
            let ct_fsi = 0;
            //-------------------
            for (let rec of this.dbWinchSummary) {
                const time = rec["sensor_time"];
                const deep = rec["sensor_deep"];
                const key = rec["sensor_key"];
                const val = rec["sensor_val"];
                //---------------------------------------------------------------------
                // データが無ければグラフ非表示にするため、数量をとる。
                if (key == "water_temp" && val != null) ct_water++;
                if (key == "oxygen" && val != null) ct_oxygen++;
                if (key == "salinity" && val != null) ct_salinity++;
                if (key == "chlorophyll" && val != null) ct_chlorophyll++;
                if (key == "turbidity" && val != null) ct_turbidity++;
                if (key == "fsi" && val != null) ct_fsi++;
                //---------------------------------------------------------------------
                if (deep == 1 && key == "water_temp") water_A.push({ x: time, y: val });
                if (deep == 2 && key == "water_temp") water_B.push({ x: time, y: val });
                if (deep == 3 && key == "water_temp") water_C.push({ x: time, y: val });
                if (deep == 4 && key == "water_temp") water_D.push({ x: time, y: val });
                if (deep == 5 && key == "water_temp") water_E.push({ x: time, y: val });
                if (deep == 6 && key == "water_temp") water_F.push({ x: time, y: val });
                if (deep == 7 && key == "water_temp") water_G.push({ x: time, y: val });
                if (deep == 8 && key == "water_temp") water_H.push({ x: time, y: val });
                if (deep == 9 && key == "water_temp") water_I.push({ x: time, y: val });
                if (deep == 10 && key == "water_temp") water_J.push({ x: time, y: val });

                if (deep == 1 && key == "oxygen") oxygen_A.push({ x: time, y: val });
                if (deep == 2 && key == "oxygen") oxygen_B.push({ x: time, y: val });
                if (deep == 3 && key == "oxygen") oxygen_C.push({ x: time, y: val });
                if (deep == 4 && key == "oxygen") oxygen_D.push({ x: time, y: val });
                if (deep == 5 && key == "oxygen") oxygen_E.push({ x: time, y: val });
                if (deep == 6 && key == "oxygen") oxygen_F.push({ x: time, y: val });
                if (deep == 7 && key == "oxygen") oxygen_G.push({ x: time, y: val });
                if (deep == 8 && key == "oxygen") oxygen_H.push({ x: time, y: val });
                if (deep == 9 && key == "oxygen") oxygen_I.push({ x: time, y: val });
                if (deep == 10 && key == "oxygen") oxygen_J.push({ x: time, y: val });

                if (deep == 1 && key == "salinity") salinity_A.push({ x: time, y: val });
                if (deep == 2 && key == "salinity") salinity_B.push({ x: time, y: val });
                if (deep == 3 && key == "salinity") salinity_C.push({ x: time, y: val });
                if (deep == 4 && key == "salinity") salinity_D.push({ x: time, y: val });
                if (deep == 5 && key == "salinity") salinity_E.push({ x: time, y: val });
                if (deep == 6 && key == "salinity") salinity_F.push({ x: time, y: val });
                if (deep == 7 && key == "salinity") salinity_G.push({ x: time, y: val });
                if (deep == 8 && key == "salinity") salinity_H.push({ x: time, y: val });
                if (deep == 9 && key == "salinity") salinity_I.push({ x: time, y: val });
                if (deep == 10 && key == "salinity") salinity_J.push({ x: time, y: val });

                if (deep == 1 && key == "chlorophyll") chlorophyll_A.push({ x: time, y: val });
                if (deep == 2 && key == "chlorophyll") chlorophyll_B.push({ x: time, y: val });
                if (deep == 3 && key == "chlorophyll") chlorophyll_C.push({ x: time, y: val });
                if (deep == 4 && key == "chlorophyll") chlorophyll_D.push({ x: time, y: val });
                if (deep == 5 && key == "chlorophyll") chlorophyll_E.push({ x: time, y: val });
                if (deep == 6 && key == "chlorophyll") chlorophyll_F.push({ x: time, y: val });
                if (deep == 7 && key == "chlorophyll") chlorophyll_G.push({ x: time, y: val });
                if (deep == 8 && key == "chlorophyll") chlorophyll_H.push({ x: time, y: val });
                if (deep == 9 && key == "chlorophyll") chlorophyll_I.push({ x: time, y: val });
                if (deep == 10 && key == "chlorophyll") chlorophyll_J.push({ x: time, y: val });

                if (deep == 1 && key == "turbidity") turbidity_A.push({ x: time, y: val });
                if (deep == 2 && key == "turbidity") turbidity_B.push({ x: time, y: val });
                if (deep == 3 && key == "turbidity") turbidity_C.push({ x: time, y: val });
                if (deep == 4 && key == "turbidity") turbidity_D.push({ x: time, y: val });
                if (deep == 5 && key == "turbidity") turbidity_E.push({ x: time, y: val });
                if (deep == 6 && key == "turbidity") turbidity_F.push({ x: time, y: val });
                if (deep == 7 && key == "turbidity") turbidity_G.push({ x: time, y: val });
                if (deep == 8 && key == "turbidity") turbidity_H.push({ x: time, y: val });
                if (deep == 9 && key == "turbidity") turbidity_I.push({ x: time, y: val });
                if (deep == 10 && key == "turbidity") turbidity_J.push({ x: time, y: val });

                if (deep == 1 && key == "fsi") fsi_A.push({ x: time, y: val });
                if (deep == 2 && key == "fsi") fsi_B.push({ x: time, y: val });
                if (deep == 3 && key == "fsi") fsi_C.push({ x: time, y: val });
                if (deep == 4 && key == "fsi") fsi_D.push({ x: time, y: val });
                if (deep == 5 && key == "fsi") fsi_E.push({ x: time, y: val });
                if (deep == 6 && key == "fsi") fsi_F.push({ x: time, y: val });
                if (deep == 7 && key == "fsi") fsi_G.push({ x: time, y: val });
                if (deep == 8 && key == "fsi") fsi_H.push({ x: time, y: val });
                if (deep == 9 && key == "fsi") fsi_I.push({ x: time, y: val });
                if (deep == 10 && key == "fsi") fsi_J.push({ x: time, y: val });
            }
            //-----------------------------------------
            const sdays = (this.daySpanValue - 1) * -1;
            const sdate = this.$moment(this.targetDate).add(sdays, "days").format("YYYY-MM-DD 00:00");
            const edate = this.$moment(this.targetDate).add(1, "days").format("YYYY-MM-DD 00:00");
            water_A.unshift({ x: sdate, y: null });
            water_B.unshift({ x: sdate, y: null });
            water_C.unshift({ x: sdate, y: null });
            water_D.unshift({ x: sdate, y: null });
            water_E.unshift({ x: sdate, y: null });
            water_F.unshift({ x: sdate, y: null });
            water_G.unshift({ x: sdate, y: null });
            water_H.unshift({ x: sdate, y: null });
            water_I.unshift({ x: sdate, y: null });
            water_J.unshift({ x: sdate, y: null });
            water_A.push({ x: edate, y: null });
            water_B.push({ x: edate, y: null });
            water_C.push({ x: edate, y: null });
            water_D.push({ x: edate, y: null });
            water_E.push({ x: edate, y: null });
            water_F.push({ x: edate, y: null });
            water_G.push({ x: edate, y: null });
            water_H.push({ x: edate, y: null });
            water_I.push({ x: edate, y: null });
            water_J.push({ x: edate, y: null });

            oxygen_A.unshift({ x: sdate, y: null });
            oxygen_B.unshift({ x: sdate, y: null });
            oxygen_C.unshift({ x: sdate, y: null });
            oxygen_D.unshift({ x: sdate, y: null });
            oxygen_E.unshift({ x: sdate, y: null });
            oxygen_F.unshift({ x: sdate, y: null });
            oxygen_G.unshift({ x: sdate, y: null });
            oxygen_H.unshift({ x: sdate, y: null });
            oxygen_I.unshift({ x: sdate, y: null });
            oxygen_J.unshift({ x: sdate, y: null });
            oxygen_A.push({ x: edate, y: null });
            oxygen_B.push({ x: edate, y: null });
            oxygen_C.push({ x: edate, y: null });
            oxygen_D.push({ x: edate, y: null });
            oxygen_E.push({ x: edate, y: null });
            oxygen_F.push({ x: edate, y: null });
            oxygen_G.push({ x: edate, y: null });
            oxygen_H.push({ x: edate, y: null });
            oxygen_I.push({ x: edate, y: null });
            oxygen_J.push({ x: edate, y: null });

            salinity_A.unshift({ x: sdate, y: null });
            salinity_B.unshift({ x: sdate, y: null });
            salinity_C.unshift({ x: sdate, y: null });
            salinity_D.unshift({ x: sdate, y: null });
            salinity_E.unshift({ x: sdate, y: null });
            salinity_F.unshift({ x: sdate, y: null });
            salinity_G.unshift({ x: sdate, y: null });
            salinity_H.unshift({ x: sdate, y: null });
            salinity_I.unshift({ x: sdate, y: null });
            salinity_J.unshift({ x: sdate, y: null });
            salinity_A.push({ x: edate, y: null });
            salinity_B.push({ x: edate, y: null });
            salinity_C.push({ x: edate, y: null });
            salinity_D.push({ x: edate, y: null });
            salinity_E.push({ x: edate, y: null });
            salinity_F.push({ x: edate, y: null });
            salinity_G.push({ x: edate, y: null });
            salinity_H.push({ x: edate, y: null });
            salinity_I.push({ x: edate, y: null });
            salinity_J.push({ x: edate, y: null });

            chlorophyll_A.unshift({ x: sdate, y: null });
            chlorophyll_B.unshift({ x: sdate, y: null });
            chlorophyll_C.unshift({ x: sdate, y: null });
            chlorophyll_D.unshift({ x: sdate, y: null });
            chlorophyll_E.unshift({ x: sdate, y: null });
            chlorophyll_F.unshift({ x: sdate, y: null });
            chlorophyll_G.unshift({ x: sdate, y: null });
            chlorophyll_H.unshift({ x: sdate, y: null });
            chlorophyll_I.unshift({ x: sdate, y: null });
            chlorophyll_J.unshift({ x: sdate, y: null });
            chlorophyll_A.push({ x: edate, y: null });
            chlorophyll_B.push({ x: edate, y: null });
            chlorophyll_C.push({ x: edate, y: null });
            chlorophyll_D.push({ x: edate, y: null });
            chlorophyll_E.push({ x: edate, y: null });
            chlorophyll_F.push({ x: edate, y: null });
            chlorophyll_G.push({ x: edate, y: null });
            chlorophyll_H.push({ x: edate, y: null });
            chlorophyll_I.push({ x: edate, y: null });
            chlorophyll_J.push({ x: edate, y: null });

            turbidity_A.unshift({ x: sdate, y: null });
            turbidity_B.unshift({ x: sdate, y: null });
            turbidity_C.unshift({ x: sdate, y: null });
            turbidity_D.unshift({ x: sdate, y: null });
            turbidity_E.unshift({ x: sdate, y: null });
            turbidity_F.unshift({ x: sdate, y: null });
            turbidity_G.unshift({ x: sdate, y: null });
            turbidity_H.unshift({ x: sdate, y: null });
            turbidity_I.unshift({ x: sdate, y: null });
            turbidity_J.unshift({ x: sdate, y: null });
            turbidity_A.push({ x: edate, y: null });
            turbidity_B.push({ x: edate, y: null });
            turbidity_C.push({ x: edate, y: null });
            turbidity_D.push({ x: edate, y: null });
            turbidity_E.push({ x: edate, y: null });
            turbidity_F.push({ x: edate, y: null });
            turbidity_G.push({ x: edate, y: null });
            turbidity_H.push({ x: edate, y: null });
            turbidity_I.push({ x: edate, y: null });
            turbidity_J.push({ x: edate, y: null });

            fsi_A.unshift({ x: sdate, y: null });
            fsi_B.unshift({ x: sdate, y: null });
            fsi_C.unshift({ x: sdate, y: null });
            fsi_D.unshift({ x: sdate, y: null });
            fsi_E.unshift({ x: sdate, y: null });
            fsi_F.unshift({ x: sdate, y: null });
            fsi_G.unshift({ x: sdate, y: null });
            fsi_H.unshift({ x: sdate, y: null });
            fsi_I.unshift({ x: sdate, y: null });
            fsi_J.unshift({ x: sdate, y: null });
            fsi_A.push({ x: edate, y: null });
            fsi_B.push({ x: edate, y: null });
            fsi_C.push({ x: edate, y: null });
            fsi_D.push({ x: edate, y: null });
            fsi_E.push({ x: edate, y: null });
            fsi_F.push({ x: edate, y: null });
            fsi_G.push({ x: edate, y: null });
            fsi_H.push({ x: edate, y: null });
            fsi_I.push({ x: edate, y: null });
            fsi_J.push({ x: edate, y: null });
            //-----------------------------------------
            // 彩度別の色見本
            // https://www.color-site.com/separate_chromas
            //-----------------------------------------
            if ([0, 1].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(1m)", data: water_A, borderColor: "#e2e3fb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 2].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(2m)", data: water_B, borderColor: "#c9cbfb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 3].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(3m)", data: water_C, borderColor: "#b0b3fb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 4].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(4m)", data: water_D, borderColor: "#979bfb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 5].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(5m)", data: water_E, borderColor: "#7d82fb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 6].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(6m)", data: water_F, borderColor: "#646afb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 7].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(7m)", data: water_G, borderColor: "#4b52fb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 8].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(8m)", data: water_H, borderColor: "#323afb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 9].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(9m)", data: water_I, borderColor: "#1922fb", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 10].includes(this.deepFilterValue)) this.chartDataSetWater.datasets.push({ label: "水温(10m)", data: water_J, borderColor: "#000afb", borderWidth: 2, pointRadius: 1.2, fill: false });

            if ([0, 1].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(1m)", data: oxygen_A, borderColor: "#fbf0e2", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 2].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(2m)", data: oxygen_B, borderColor: "#fbe6c9", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 3].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(3m)", data: oxygen_C, borderColor: "#fbdbb0", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 4].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(4m)", data: oxygen_D, borderColor: "#fbd097", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 5].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(5m)", data: oxygen_E, borderColor: "#fbc67d", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 6].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(6m)", data: oxygen_F, borderColor: "#fbbb64", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 7].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(7m)", data: oxygen_G, borderColor: "#fbb04b", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 8].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(8m)", data: oxygen_H, borderColor: "#fba632", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 9].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(9m)", data: oxygen_I, borderColor: "#fb9b19", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 10].includes(this.deepFilterValue)) this.chartDataSetOxygen.datasets.push({ label: "DO(10m)", data: oxygen_J, borderColor: "#fb9100", borderWidth: 2, pointRadius: 1.2, fill: false });

            if ([0, 1].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(1m)", data: salinity_A, borderColor: "#d0d2e7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 2].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(2m)", data: salinity_B, borderColor: "#b8bce7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 3].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(3m)", data: salinity_C, borderColor: "#a2a7e7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 4].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(4m)", data: salinity_D, borderColor: "#8a92e7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 5].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(5m)", data: salinity_E, borderColor: "#737de7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 6].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(6m)", data: salinity_F, borderColor: "#5c68e7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 7].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(7m)", data: salinity_G, borderColor: "#4553e7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 8].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(8m)", data: salinity_H, borderColor: "#2e3ee7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 9].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(9m)", data: salinity_I, borderColor: "#1728e7", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 10].includes(this.deepFilterValue)) this.chartDataSetSalinity.datasets.push({ label: "塩分(10m)", data: salinity_J, borderColor: "#0013e7", borderWidth: 2, pointRadius: 1.2, fill: false });

            if ([0, 1].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(1m)", data: chlorophyll_A, borderColor: "#d3e6cf", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 2].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(2m)", data: chlorophyll_B, borderColor: "#c0e6b8", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 3].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(3m)", data: chlorophyll_C, borderColor: "#ade6a1", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 4].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(4m)", data: chlorophyll_D, borderColor: "#9ae68a", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 5].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(5m)", data: chlorophyll_E, borderColor: "#87e673", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 6].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(6m)", data: chlorophyll_F, borderColor: "#73e65c", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 7].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(7m)", data: chlorophyll_G, borderColor: "#60e645", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 8].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(8m)", data: chlorophyll_H, borderColor: "#4de62e", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 9].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(9m)", data: chlorophyll_I, borderColor: "#3ae617", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 10].includes(this.deepFilterValue)) this.chartDataSetChloro.datasets.push({ label: "クロロ(10m)", data: chlorophyll_J, borderColor: "#27e600", borderWidth: 2, pointRadius: 1.2, fill: false });

            if ([0, 1].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(1m)", data: turbidity_A, borderColor: "#e7dad0", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 2].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(2m)", data: turbidity_B, borderColor: "#e7ceb9", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 3].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(3m)", data: turbidity_C, borderColor: "#e7c1a2", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 4].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(4m)", data: turbidity_D, borderColor: "#e7b58a", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 5].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(5m)", data: turbidity_E, borderColor: "#e7a973", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 6].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(6m)", data: turbidity_F, borderColor: "#e79c5c", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 7].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(7m)", data: turbidity_G, borderColor: "#e79045", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 8].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(8m)", data: turbidity_H, borderColor: "#e7832e", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 9].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(9m)", data: turbidity_I, borderColor: "#e77717", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 10].includes(this.deepFilterValue)) this.chartDataSetTurbidity.datasets.push({ label: "濁度(10m)", data: turbidity_J, borderColor: "#e76a00", borderWidth: 2, pointRadius: 1.2, fill: false });

            if ([0, 1].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(1m)", data: fsi_A, borderColor: "#e7dad0", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 2].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(2m)", data: fsi_B, borderColor: "#e7ceb9", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 3].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(3m)", data: fsi_C, borderColor: "#e7c1a2", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 4].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(4m)", data: fsi_D, borderColor: "#e7b58a", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 5].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(5m)", data: fsi_E, borderColor: "#e7a973", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 6].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(6m)", data: fsi_F, borderColor: "#e79c5c", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 7].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(7m)", data: fsi_G, borderColor: "#e79045", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 8].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(8m)", data: fsi_H, borderColor: "#e7832e", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 9].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(9m)", data: fsi_I, borderColor: "#e77717", borderWidth: 2, pointRadius: 1.2, fill: false });
            if ([0, 10].includes(this.deepFilterValue)) this.chartDataSetFSI.datasets.push({ label: "有害(10m)", data: fsi_J, borderColor: "#e76a00", borderWidth: 2, pointRadius: 1.2, fill: false });

            if (ct_water == 0) this.chartDataSetWater = null;
            if (ct_oxygen == 0) this.chartDataSetOxygen = null;
            if (ct_salinity == 0) this.chartDataSetSalinity = null;
            if (ct_chlorophyll == 0) this.chartDataSetChloro = null;
            if (ct_turbidity == 0) this.chartDataSetTurbidity = null;
            if (ct_fsi == 0) this.chartDataSetFSI = null;
        },
        //====================================================
    },
};
</script>
